import React from 'react';
import { Responses } from '../../interfaces';
import { __t } from '../../../../../base/utils/t';

import './styles.scss';

interface Props {
    vacancyId: string;
    responses: Responses;
    className?: string;
}

export const ActivityWidget = ({
    vacancyId,
    responses: { applied, appliedNew, invited, mutual, mutualNew },
    className = '',
}: Props) => {
    return (
        <div className={`activity-widget ${className}`}>
            <a
                href={`/responses?vacancy=${vacancyId}`}
                className='activity-widget__item'
                target='_blank'
                rel='noreferrer'
            >
                {Number(appliedNew) > 0 ? <div className='activity-widget__new-count'>+{appliedNew}</div> : null}
                <div className='activity-widget__count'>{applied}</div>
                <div className='activity-widget__title'>{__t('отклики')}</div>
            </a>

            <a
                href={`/responses/invited?vacancy=${vacancyId}`}
                className='activity-widget__item'
                target='_blank'
                rel='noreferrer'
            >
                <div className='activity-widget__count'>{invited}</div>
                <div className='activity-widget__title'>{__t('мои запросы')}</div>
            </a>

            <a
                href={`/responses/mutual?vacancy=${vacancyId}`}
                className='activity-widget__item'
                target='_blank'
                rel='noreferrer'
            >
                {Number(mutualNew) > 0 ? <div className='activity-widget__new-count'>+{mutualNew}</div> : null}
                <div className='activity-widget__count'>{mutual}</div>
                <div className='activity-widget__title'>{__t('взаимных')}</div>
            </a>
        </div>
    );
};
